export const clearSdpUrlParams = () => {
	// remove the route from url here so SDP opens on route we specify in init object
	const pageUrl = window.location;
	const searchParams = new URLSearchParams(pageUrl.search);
	if (searchParams.has('route')) {
		// remove unused params
		searchParams.delete('route');
		searchParams.delete('dsLoad');

		// set autoOpen=false to avoid
		// re-open behavior after closing
		searchParams.set('autoOpen', 'false');

		// form new url and push into history
		const url = new URL(`${window.location.protocol}//${window.location.hostname}${window.location.pathname}?${searchParams.toString()}`);
		window.history.pushState({}, document.title, url);
	}
};
